module.exports = __webpack_public_path__ + "static/media/callEnd.8dfac3d9.svg";